import Image from "next/image";
import { useState, useEffect, useContext } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { useSession, signOut } from "next-auth/react";
import { toBackend } from "../utilities/requestsTypes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Home(props) {
  const { data, status } = useSession();

  const router = useRouter();
  const [hide, setHide] = useState(true);
  const [helpHide, setHelpHide] = useState(true);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [usr, setUsr] = useState({ user: null, token: null });
  const [userProfile, setUserProfile] = useState({
    data: {
      fullName: "",
      profilePicUrl: "/images/profilepic_avatar.png",
    },
  });

  // useEffect(() => {
  //   getProfile();
  //   console.log(loginState);
  // }, []);

  // const u = getAuth(app);

  useEffect(() => {
    if (status === "authenticated") {
      if (!data.user.fullyRegistered) {
        router.push("/nameandphone");
      }

      if (!data.user.emailVerified) {
        router.push("/verifyemail");
      }

      getProfile();
    }
  }, [status]);

  const getProfile = async () => {
    try {
      const u = await toBackend.get("user/profile", {
        headers: {
          accesstoken: data.user.token,
        },
      });
      setUserProfile(u.data);
    } catch (error) {
      console.log(error);
    }
  };

  // const logOut = async () => {
  //   signOut(u).then(() => {
  //     Cookies.remove("user");
  //     localStorage.removeItem("authtoken");
  //   location.reload();
  //   })
  //   .catch((error) => {
  //     console.log(error);
  //   });
  // }

  const showSearchResult = () => {
    router.push("/searchresult/" + search);
  };

  return (
    <div
      className={`w-full flex px-6 gap-4 xl:gap-10 relative items-center justify-between py-2 h-[70px]`}
    >
      <Link href="/">
        <div>
          <div className={`block md:hidden`}>
            <Image
              src={`/images/logo.png`}
              layout="fixed"
              alt="none"
              className="hover:cursor-pointer"
              width={80}
              height={40}
            />
          </div>
          <div className={`hidden md:block`}>
            <Image
              src={`/images/logo.png`}
              layout={`fixed`}
              alt="none"
              className="hover:cursor-pointer"
              width={110}
              height={50}
            />
          </div>
        </div>
      </Link>

      <nav
        className={`w-full lg:flex lg:items-center lg:w-auto z-100 ${open ? "flex flex-row bg-primary" : "block xl:block"
          }`}
      >
        <div className="flex justify-center absolute top-4 left-[50%] z-50 translate-x-[-50%] w-fit hidden md:block">
          <div className="xl:w-[600px] md:block">
            <div className="relative flex w-full rounded">

              <div
                className="relative outline-none flex block w-full items-center text-base font-normal bg-gray-200 text-gray-700 bg-clip-padding border border-solid border-gray-300 rounded-md transition ease-in-out m-0 focus:text-gray-700 focus:bg-gray-100 justify-between"
                onClick={() => { router.push("/searchresult") }}
              >
                <div className="ml-4">Search for product, category</div>
                <div className="px-4 ml-[-10px] flex z-10 py-2.5 bg-yellow text-primary font-medium text-xs leading-tight uppercase rounded-r-md hover:text-white hover:shadow-lg focus:bg-blue-700  focus:shadow-lg outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out items-center">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="search"
                    className="w-4"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                    ></path>
                  </svg>
                </div>
              </div>

              {/* <input
                type="search"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                className="relative outline-none flex-auto block px-3 py-1.5 text-base font-normal bg-gray-200 text-gray-700 bg-clip-padding border border-solid border-gray-300 rounded-md transition ease-in-out m-0 focus:text-gray-700 focus:bg-gray-100"
                placeholder="Search for product, category"
              />
              <button
                className="px-4 ml-[-10px] flex z-10 py-2.5 bg-yellow text-primary font-medium text-xs leading-tight uppercase rounded-r-md hover:text-white hover:shadow-lg focus:bg-blue-700  focus:shadow-lg outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out items-center"
                type="button"
                id="button-addon2"
                onClick={showSearchResult}
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="search"
                  className="w-4"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                  ></path>
                </svg>
              </button> */}
              {/* ${search.length < 3 ? "hidden": "block"} */}
            </div>
          </div>
        </div>
        <div
          className={`${status == "loading" ? "flex" : "hidden"
            } justify-center items-center`}
        >
          Loading...
        </div>
        <div
          className={`${status == "unauthenticated" ? "flex" : "hidden"
            }  justify-end w-full gap-2 xl:gap-6`}
        >
          {/* Search Button on smaller devices */}
          {/* <button className={`p-2 block md:hidden rounded-full text-primary`}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="search"
              className="w-4"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
              ></path>
            </svg>
          </button> */}

          <div className="flex justify-center">
            <div>
              <HelpButton hide={helpHide} setHide={setHelpHide} />
            </div>
          </div>
          <button
            className={``}
            onClick={() => {
              router.push("/login");
            }}
          >
            Login
          </button>
          <button
            className={`flex flex-nowrap items-center justify-center w-[80px] p-1 rounded-[20px] bg-primary text-white`}
            onClick={() => {
              router.push("/signup");
            }}
          >
            Sign Up
          </button>
        </div>

        <div
          className={`${status == "authenticated" ? "flex" : "hidden"
            }  justify-end w-full gap-2 xl:gap-6`}
        >
          <div className={`flex items-center gap-x-2 text-bold text-xl`}>
            <button>
              <AiOutlineShoppingCart className={`text-[25px]`} />
            </button>
            {/* <HelpButton hide={helpHide} setHide={setHelpHide} /> */}
            {/* <button className={`bg-primary text-white text-sm p-1 rounded`} onClick={logOut}>Log Out</button> */}

            <div className="dropdown relative bg-white">
              <button
                className="
          dropdown-toggle
          px-2
          py-2.5
          transition
          duration-150
          ease-in-out
          flex
          relative
          items-center
          whitespace-nowrap
        "
                type="button"
                id="dropdownMenuButton1"
                onClick={() => {
                  setHide(!hide);
                }}
              >
                <Image
                  src={data ? data.user.image : ""}
                  className={`rounded-full`}
                  layout="fixed"
                  width={25}
                  height={25}
                />
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="caret-down"
                  className="w-2 ml-2"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                >
                  <path
                    fill="currentColor"
                    d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                  ></path>
                </svg>
              </button>
              <ul
                className={`
          dropdown-menu
          absolute
          min-w-max
          block
          bg-white
          text-base
          ${hide == true ? "hidden" : "block"}
          z-[200]
          float-left
          py-2
          right-0
          list-none
          text-left
          rounded-lg
          shadow-lg
          mt-1
          m-0
          bg-clip-padding
          border-none
        `}
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <div
                    className="
              dropdown-item
              text-sm
              py-2
              px-4
              gap-4
              font-normal
              w-full
              flex
              items-center
              whitespace-nowrap
              bg-transparent
              text-gray-700
              hover:bg-gray-100
            "
                  >
                    {/* <Image src={userProfile.profilePicUrl} className={`rounded-full`} layout='fixed'  width={60} height={60} /> */}
                    <div className={`flex flex-col gap-2`}>
                      <div className={`font-bold`}>{userProfile.fullName}</div>
                      <div
                        className={`bg-primary text-white rounded-[20px] py-1 px-2 cursor-pointer`}
                        onClick={() => {
                          router.push("/profile");
                        }}
                      >
                        View profile
                      </div>
                    </div>
                  </div>
                </li>
                <hr className={`w-[90%] mx-auto my-2 border-yellow`} />
                <li
                  className="
              dropdown-item
              text-sm
              py-2
              px-4
              font-normal
              block
              w-full
              whitespace-nowrap
              bg-transparent
              text-gray-700
              hover:bg-gray-100
            "
                >
                  <Link href="/profile/chats">Chats</Link>
                </li>
                <li
                  className="
              dropdown-item
              text-sm
              py-2
              px-4
              font-normal
              block
              w-full
              whitespace-nowrap
              bg-transparent
              text-gray-700
              hover:bg-gray-100
            "
                >
                  <Link href="/profile/offers">Offers</Link>
                </li>
                <li
                  className="
              dropdown-item
              text-sm
              py-2
              px-4
              font-normal
              block
              w-full
              whitespace-nowrap
              bg-transparent
              text-gray-700
              hover:bg-gray-100
            "
                >
                  <Link href="/profile/notifications">Notifications</Link>
                </li>
                <li
                  className="
        dropdown-item
        text-sm
        py-2
        px-4
        font-normal
        block
        w-full
        whitespace-nowrap
        bg-transparent
        text-gray-700
        hover:bg-gray-100
      "
                >
                  <Link href="#">Auction</Link>
                </li>
                <li
                  className="
        dropdown-item
        text-sm
        py-2
        px-4
        font-normal
        block
        w-full
        whitespace-nowrap
        bg-transparent
        text-gray-700
        hover:bg-gray-100
      "
                >
                  <Link href="/profile/settings">Settings</Link>
                </li>
                <hr className={`w-[90%] mx-auto my-2 border-yellow`} />
                <li>
                  <div
                    className="
              dropdown-item
              text-sm
              py-2
              px-4
              font-normal
              block
              w-full
              whitespace-nowrap
              bg-transparent
              text-gray-700
              hover:bg-gray-100
              cursor-pointer
            "
                    onClick={signOut}
                  >
                    Log Out
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

function HelpButton({ hide, setHide }) {
  return (
    <div className="dropdown relative">
      <button
        className="
          dropdown-toggle
          px-2
          py-2.5
          transition
          duration-150
          ease-in-out
          flex
          relative
          items-center
          whitespace-nowrap
        "
        type="button"
        id="dropdownMenuButton1"
        onClick={() => {
          setHide(!hide);
        }}
      >
        Help
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="caret-down"
          className="w-2 ml-2"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
        >
          <path
            fill="currentColor"
            d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
          ></path>
        </svg>
      </button>
      <ul
        className={`
          dropdown-menu
          absolute
          min-w-max
          block
          bg-white
          text-base
          ${hide == true ? "hidden" : "block"}
          z-50
          float-left
          py-2
          list-none
          text-left
          rounded-lg
          shadow-lg
          mt-1
          m-0
          bg-clip-padding
          border-none
        `}
        aria-labelledby="dropdownMenuButton1"
      >
        <li>
          <a
            className="
              dropdown-item
              text-sm
              py-2
              px-4
              font-normal
              block
              w-full
              whitespace-nowrap
              bg-transparent
              text-gray-700
              hover:bg-gray-100
            "
            href="#"
          >
            Contact Us
          </a>
        </li>
        <li>
          <a
            className="
              dropdown-item
              text-sm
              py-2
              px-4
              font-normal
              block
              w-full
              whitespace-nowrap
              bg-transparent
              text-gray-700
              hover:bg-gray-100
            "
            href="#"
          >
            FAQ&apos;s
          </a>
        </li>
      </ul>
    </div>
  );
}
